<template>
  <div class="bread-crumb">
    <el-breadcrumb separator="/" v-if="!isDetails">
        <el-breadcrumb-item v-for="(item, index) in matched" :key="index" :class="{'is-active':index==1}">{{item.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-breadcrumb separator="/" v-else>
        <el-breadcrumb-item v-for="(item, index) in matched" :key="index" v-show="index<1">{{item.meta.title}}</el-breadcrumb-item>
        <el-breadcrumb-item class="is-router" :to="{name: fromType?meta['parentName'+fromType]:meta.parentName}">{{fromType?meta['parentTitle'+fromType]:meta.parentTitle}}</el-breadcrumb-item>
        <el-breadcrumb-item class="is-active">{{title?title:meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'breadcrumb',
  props: {
    isDetails: { // 是否是四级页面(详情页面)
      type: Boolean,
      default: false
    },
    title: { // 可能有多个详情同用一个页面
      type: String,
      default: ''
    },
    fromType: { // 跳转路由可能不同, 需要在路由中设置多个parentName,parentTitle
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      matched: [],
      meta: {}
    }
  },
  watch: {
    $route: {
      handler (newVal, oldVal) {
        // console.log(newVal)
        this.getRouteInfo(newVal)
      },
      deep: true
    },
    fromType (newVal, oldVal) {
      // console.log('fromType', newVal)
    }
  },
  created () {
    this.getRouteInfo(this.$route)
    // console.log('breadcrumb', this.$route)
  },
  methods: {
    getRouteInfo (data) {
      this.matched = data.matched
      this.meta = data.meta
      // console.log(this.matched)
    }
  }
}
</script>

<style lang="scss" scoped>
.bread-crumb{
  display: inline-block;
  padding: 6px 0;
  height: 40px;
  overflow: hidden;
}
</style>
